import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function BuildIcon(props: IconProps) {
    return <Icon {...props} iconKey={"build"}/>
}
